// extracted by mini-css-extract-plugin
export default {"container":"jogadorInput_container__NamNj","avatar":"jogadorInput_avatar__X3qZ3","input":"jogadorInput_input__G3VIm","gender":"jogadorInput_gender__4alUk"};